import $i from "~/i18n";
import router from "~/routes.js";

export const checkOfferCode = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post("/offcode/check-course-price", payload);
    if (data.state != 200) {
      if (data.state == 404) {
        commit(
          "notifications/error",
          { message: "کد تخفیف یافت نشد", title: "خطای کد تخفیف" },
          { root: true }
        );
      }
      return;
    }
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    // commit("SET_DATA", { data: data.price, id: "priceOffer" });
    commit("UPDATE_DATA", {
      data: data.price,
      id: "singleItem",
      value: "course_price"
    });
  } catch (error) {
    console.log(error);
  }
};
export const showOffer = async ({ commit }, payload) => {
  commit("SET_DATA", { data: true, id: "show" });
  commit("SET_DATA", { data: payload, id: "singleItem" });
};
export const postPrebillMeli = async (context, payload) => {
  try {
    let res = await axios.post("/payment/request", payload);
    let NewURL = res.data.message.replace("\u202b\u202a", "");
    window.location.href = NewURL;
  } catch (error) {
    console.log(error);
  }
};
export const postPrebill = async (context, payload) => {
  try {
    let { data } = await axios.post("/bill/prebill", payload);
    if (data.err) {
      return Promise.reject(data);
    }

    if (data.state != 200) {
      if (data.state == 404) {
        context.commit(
          "notifications/error",
          { message: "کد تخفیف یافت نشد", title: "خطای کد تخفیف" },
          { root: true }
        );
      }
      return;
    }
    if(typeof  data.gateway === "boolean" && data.gateway){
      context.commit("notifications/success", {
        message: "خرید دوره",
        title: "دوره مورد نظر به لیست دوره های شما اضافه شد."
      },{ root: true });
      let params = router.history.current.params;
      let link =  "/courses/" +params.en_category +"/" +params.en_subcategory +"/" +params.id + "/" + params.course_title_encourses;
      router.push(`${link}/list-content`);

    } else {
      context.commit("notifications/success", {
        message: "انتقال به بانک",
        title: "لطفا صبور باشید درحال انتقال صفحه به بانک هستیم."
      },{ root: true });
     window.location.replace(data.gateway);
    }
  } catch (error) {
    return Promise.reject(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/basket/actions.js